import { commonComponents as cc } from "@/components/common";
import { diaryByIdQueryOptions } from "@/features/diaries/api";
import DiaryTitle from "@/features/diaries/components/DiaryTitle";
import { hooks as h } from "@/hooks";
import { Outlet, createFileRoute } from "@tanstack/react-router";
const Edit = () => {
	const { diaryId } = Route.useParams();
	const { diary } = Route.useLoaderData();

	h.useNav([
		{ route: { to: "/diaries" }, label: "Diaries" },
		{
			route: { to: "/diaries/$diaryId/home/new", params: { diaryId: diaryId } },
			label: "Diary",
		},
		{
			route: { to: "/diaries/$diaryId/edit", params: { diaryId: diaryId } },
			label: "Edit",
		},
	]);

	return (
		<section className="md-width">
			<DiaryTitle diary={diary} editing={true} />
			<Outlet />
		</section>
	);
};

export const Route = createFileRoute("/_app/diaries/$diaryId/edit")({
	component: Edit,
	loader: async ({ context, params }) => {
		const diary = await context?.queryClient.ensureQueryData(
			diaryByIdQueryOptions(params.diaryId),
		);
		return { diary };
	},
});
